module.exports = __webpack_public_path__ + "img/running-sweating.99f703f9.png";